import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  productsInCart: localStorage.getItem('cartItems')
    ? JSON.parse(localStorage.getItem('cartItems'))
    : [],
  cartTotalQuantity: JSON.parse(localStorage.getItem('cartItemsQuantity')) ?? 0,
  cartTotalPrice: JSON.parse(localStorage.getItem('cartTotalPrice')) ?? 0,
}

export const productsSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addInCart: (state, action) => {
      const itemIndex = state.productsInCart.findIndex(
        (item) => item.id === action.payload.id
      )
      if (itemIndex >= 0) {
        state.productsInCart[itemIndex].cartQuantity += action.payload.quantity
        state.cartTotalQuantity += action.payload.quantity
      } else {
        const tempProduct = {
          ...action.payload,
          cartQuantity: action.payload.quantity,
        }
        state.productsInCart.push(tempProduct)
        state.cartTotalQuantity += action.payload.quantity
      }
      localStorage.setItem('cartItems', JSON.stringify(state.productsInCart))
      localStorage.setItem(
        'cartItemsQuantity',
        JSON.stringify(state.cartTotalQuantity)
      )
      state.cartTotalPrice += action.payload.price * action.payload.quantity
      localStorage.setItem(
        'cartTotalPrice',
        JSON.stringify(state.cartTotalPrice)
      )
    },
    decreaseCart: (state, action) => {
      const itemIndex = state.productsInCart.findIndex(
        (item) => item.id === action.payload.id
      )
      if (state.productsInCart[itemIndex].cartQuantity > 1) {
        state.productsInCart[itemIndex].cartQuantity -= 1
      } else
        state.productsInCart.filter((item) => item.id !== action.payload.id)
    },
    increaseCart: (state, action) => {
      const itemIndex = state.productsInCart.findIndex(
        (item) => item.id === action.payload.id
      )
      if (itemIndex >= 0) {
        console.log(itemIndex)
        state.productsInCart[itemIndex].cartQuantity += 1
        state.cartTotalQuantity += 1
      }
    },
  },
})

export const { addInCart, increaseCart, decreaseCart } = productsSlice.actions
export default productsSlice.reducer
